// extracted by mini-css-extract-plugin
export default {"img1":"helpSexRoulette_img1__LRAYz","img2":"helpSexRoulette_img2__IxkGn","animate":"helpSexRoulette_animate__gei6w","rotate":"helpSexRoulette_rotate__eRuE4"};